import { createDynamicMiddleware } from "@reduxjs/toolkit/react";

import type { AppDispatch, RootState } from "../store";

const dynamicMiddleware = createDynamicMiddleware();

const {
  middleware,
  addMiddleware,
  withMiddleware,
  createDispatchWithMiddlewareHook,
} = dynamicMiddleware;

interface MiddlewareApiConfig {
  state: RootState;
  dispatch: AppDispatch;
}

export const addAppMiddleware = addMiddleware.withTypes<MiddlewareApiConfig>();

export const withAppMiddleware =
  withMiddleware.withTypes<MiddlewareApiConfig>();

export const createAppDispatchWithMiddlewareHook =
  createDispatchWithMiddlewareHook.withTypes<MiddlewareApiConfig>();

export default middleware;
